import TodoTemplate from "../components/todo/TodoTemplate";

const MainPage = () => {
  return <TodoTemplate />;
};

export default MainPage;
